// function to scroll to a section
const  scrollToSection = (sectionId) => {
  const section = document.querySelector(`#${sectionId}`);
  // section.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
}

export default scrollToSection;
